import type {BirdScore} from './detections';

// A completed result remains useful for the session list until the model deadline.
// It must not flash as a current call once it is more than six seconds old.
export const BIRD_INFERENCE_TIMEOUT_MS=15000;
export const BIRD_LIVE_RESULT_AGE_MS=6000;
export const BIRD_AUDIO_STALL_MS=8000;

export function validBirdScores(value:unknown,expectedCount:number):value is BirdScore[]{
 if(!Array.isArray(value)||value.length!==expectedCount||!expectedCount)return false;
 const indices=new Set<number>();
 for(const score of value){
  if(!score||!Number.isInteger(score.index)||score.index<0||score.index>=expectedCount||indices.has(score.index)||typeof score.commonName!=='string'||!score.commonName.trim()||!Number.isFinite(score.confidence)||score.confidence<0||score.confidence>1||!Number.isFinite(score.geoscore)||score.geoscore<0||score.geoscore>1)return false;
  indices.add(score.index);
 }
 return true;
}
